// js
import AdoptionOverviewPPTX from '../../../components/analytics/pptx/AdoptionOverviewPPTX';
import { connect } from 'react-redux';
import { getAdoptionGoalsByAreaForOverviewChart, getUserGroupsForOverviewChart } from '../../../selectors/analytics/adoptionSelectors';
import { getAbilities } from '../../../selectors/dsa/abilitiesSelectors';


const mapStateToProps = (state) => {
  return {
    pptxTarget: 'pptx_adoption_overview',
    abilities: getAbilities(state),
    getAdoptionGoalsByArea: (props) => getAdoptionGoalsByAreaForOverviewChart(state, props),
    getUserGroups: () => getUserGroupsForOverviewChart(state)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AdoptionOverviewPPTX);



// WEBPACK FOOTER //
// ./src/containers/analytics/pptx/AdoptionOverviewPPTX.js